import { useMutation } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";

export default function useColors() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useList() {
        return useMutation({
            mutationFn: () => axiosPrivate.get(`/v1/colors/list`).then(parseSuccessResponseData),
        });
    }

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/colors/create`, parameters).then(parseSuccessResponseData),
        });
    }

    function useUpdate() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/colors/update`, parameters).then(parseSuccessResponseData),
        });
    }

    function useDelete() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.delete(`/v1/colors/delete/${parameters.id}`).then(parseSuccessResponseData),
        });
    }

    return { useList, useCreate, useUpdate, useDelete };
}
